// Scope names this frontend checks for (see CONTEXT.md's "Scope" entry).
// Reconciled (ticket 12) against the backend's actual vocabulary -
// portal/server/user/core/scopes.py's `Scope` class and `compute_scopes()`.
//
// - "Ensaras Admin" (legacy role) = an org admin whose org is literally
//   named "Ensaras". The backend grants such a user BOTH `org:admin` and
//   `ensaras:admin` together (see `compute_scopes()`), so
//   ENSARAS_ADMIN_SCOPE checks the more specific claim.
// - "Client Admin" (legacy role) = an org admin of any other (client) org.
//   The backend has no separate scope for this - it's simply `org:admin`
//   without `ensaras:admin`. CLIENT_ADMIN_SCOPE therefore maps to the same
//   `org:admin` scope Ensaras admins also carry; `selectIsAdmin`'s
//   isEnsarasAdmin-OR-isClientAdmin shape means this doesn't change who is
//   considered an admin overall.
export const ENSARAS_ADMIN_SCOPE = "ensaras:admin";
export const CLIENT_ADMIN_SCOPE = "org:admin";

// No backend equivalent exists yet (confirmed against
// portal/server/user/core/scopes.py - MQTT access is not part of the Scope
// vocabulary at all). The closest backend concept is the per-team
// `Team.mqtt_enabled` boolean, which is orthogonal to per-user
// authorization scopes and already reaches the frontend as team data,
// separately from auth state. See ticket 13 - this constant currently
// can never match a real issued Scope, so `selectCanAccessMqttFeatures`
// cannot resolve true until that's resolved.
export const MQTT_ACCESS_SCOPE = "mqtt_access";
